<template>
    <div
        class="modal"
        :class="{'is-active': filePreviewModalIsShown}"
        @click="hideFilePreviewModal"
    >
        <div class="modal-background"></div>
        <div class="modal-content">
            <p class="image">
                <img :src="imgUrl" alt="">
            </p>
        </div>
        <button
            aria-label="close"
            class="modal-close is-large"
            @click="hideFilePreviewModal"
        ></button>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
name: "BaseFileImagePreviewModal",
    props: {
        imgUrl: String,
    },
    computed: {
        ...mapState('fileManagement', [
            'filePreviewModalIsShown',
        ]),
    },
    methods: {
        ...mapActions('fileManagement', [
            'hideFilePreviewModal'
        ])
    }
}
</script>

<style lang="scss" scoped>
    .modal-content {
        width: 90%;
        height: 100%;

        .image {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            overflow: hidden;

            img {
                width: auto;
                max-height: 100%;
            }
        }
    }
</style>